module.exports = __webpack_public_path__ + "files/d16367eb87913a56d7f9205bc25f245b.png";